import { render, staticRenderFns } from "./VehiclePositionModal.vue?vue&type=template&id=c9453afa&scoped=true"
import script from "./VehiclePositionModal.vue?vue&type=script&lang=js"
export * from "./VehiclePositionModal.vue?vue&type=script&lang=js"
import style0 from "./VehiclePositionModal.vue?vue&type=style&index=0&id=c9453afa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9453afa",
  null
  
)

export default component.exports